module.exports = __webpack_public_path__ + "img/sticker-best.ec6f430a.png";